"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var styled_1 = __importDefault(require("@emotion/styled"));

var StyledDisplayField = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 20px 0 10px;\n"], ["\n  margin: 20px 0 10px;\n"])));
var DisplayFieldName = styled_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding: 0 10px 0 0;\n  font-weight: bold;\n"], ["\n  padding: 0 10px 0 0;\n  font-weight: bold;\n"])));
var DisplayFieldValue = styled_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  padding: 0;\n  display: block;\n"], ["\n  padding: 0;\n  display: block;\n"])));

exports.DisplayField = function (_a) {
  var name = _a.name,
      children = _a.children;
  return react_1.default.createElement(StyledDisplayField, null, react_1.default.createElement(DisplayFieldName, null, name, ":"), react_1.default.createElement(DisplayFieldValue, null, children));
};

var templateObject_1, templateObject_2, templateObject_3;